/**
 * @readonly
 * @typedef {Object} ObjectGroupModel
 * @property {string} NAME - The object group name
 * @property {string} OBJECT_GROUP_ID - The ID of the object group
 * @property {string} OBJECT_GROUP_TYPE - Object group type
 * @property {string} CONTROL_FLAGS - Control flags
 */
export const ObjectGroupModel = {
    NAME: 'name',
    OBJECT_GROUP_ID: 'objectGroupId',
    OBJECT_GROUP_TYPE: 'objectGroupType',
    CONTROL_FLAGS: 'controlFlags'
}
